import React from 'react'
import './VirtualTour.css'
const Virtualtour = () => {
  const src = 'https://my.matterport.com/show/?m=ZYJNENmbsPr';
  return (
    <section id='videotour' className='virtual-tour section'>
        <div className='section_title'>
        Discover Your Dream Home from Anywhere
        </div>
        <div className='section_subtitle'>
        Unlock Your Personal Paradise.
        </div>
        <div className='virtual-tour-content'>
        <iframe src={src} className='virtual-tour-frame' title='Virtual Tour' frameborder='0' allowfullscreen allow='xr-spatial-tracking'></iframe>
        </div>
    </section>
  )
}

export default Virtualtour
